<template>
  <div class="material-report-detail">
    <div class="c-form">
      <div class="material-info-row">
        <span>
          素材ID：
          <span class="text">{{ id }}</span>
        </span>
        <span>
          素材名称：
          <span class="text">{{ name }}</span>
        </span>
        <span>
          设计者：
          <span class="text">{{ author }}</span>
        </span>
        <span>
          上传时间：
          <span class="text">{{ creatime }}</span>
        </span>
      </div>
      <ElForm inline label-width="74px" @submit.native.prevent class="elementui-common-form-styles" v-highlight>
        <ElFormItem label="数据游戏组">
          <el-select v-model="dataGroupId" filterable clearable @change="sendEvent" placeholder="全部">
            <el-option v-for="item in GAME_GROUPS" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem label="数据游戏">
          <el-select v-model="dataGameId" filterable clearable @change="sendEvent" placeholder="全部">
            <el-option v-for="item in GAMES" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem label="媒体" label-width="40px">
          <el-select v-model="mediaId" filterable clearable @change="sendEvent" style="width: 90px" placeholder="全部">
            <el-option v-for="item in MEDIAS" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem label="统计时间">
          <DateRangePicker v-model="datetime" :clearable="false" @change="handleDatetime" style="width: 220px"></DateRangePicker>
        </ElFormItem>
      </ElForm>
    </div>
    <div class="c-m-table">
      <Tabs v-model="platform" @on-click="sendEvent" class="c-table-list">
        <TabPane name="0" label="全部"></TabPane>
        <TabPane name="1" label="Andriod"></TabPane>
        <TabPane name="2" label="iOS"></TabPane>
        <template slot="extra">
          <Button @click="modalColumn = true">自定义列</Button>
          <Button icon="md-download" @click="downData" style="margin-left: 2px">数据导出</Button>
        </template>
      </Tabs>

      <Viewport v-model="tableHeight">
        <m-report-table
          :loading="loading"
          :height="tableHeight - 10"
          :data="tableList"
          :columns="tableCol"
          :summary="summaries"
          @on-sort="sortTable"
        />
      </Viewport>
    </div>
    <!-- 自定义列 -->
    <custom-column v-model="modalColumn" :data="columns" :sub-title="['基本数据', '创角留存', '创角LTV']" @on-select="selectColumn" />
  </div>
</template>
<script>
import moment from 'moment'
import { isArray } from '@/common/js/utils'
import { datetimeToDay } from '@/common/js/filters'
import { HOST_API } from '@/api/config'
import mixinTable from './mixin_table'
import { reportCols, analysisCols } from '../data/material_record_detail_column'

import DateRangePicker from '@/components/date-range-picker/index.vue'
import CustomColumn from '@/components/converter/custom-column.vue'
import MReportTable from './components/detail-table'

import { getMaterialRecordDetail, getMaterialAnalysisDetail } from '@/api/report.model'
import { initPageData, GAME_GROUPS, GAMES, MEDIAS } from '@/data/global-opts'
const PAGE_REQUIRED_OPTS = initPageData([GAME_GROUPS, GAMES, MEDIAS])

let columns = []
export default {
  name: 'materialdetail',
  mixins: [mixinTable],
  components: { CustomColumn, MReportTable, DateRangePicker },
  computed: {
    ...PAGE_REQUIRED_OPTS,
    tableCol() {
      return this.columns.filter((ret) => !ret.show)
    }
  },
  methods: {
    summaries(param) {
      const { columns } = param
      const data = JSON.parse(JSON.stringify(this.sumdata))
      const sums = []
      columns.forEach((column, index) => {
        const prop = column.property
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const idx = ['planName', 'mediaName'].indexOf(prop)
        if (idx > -1) sums[index] = data[prop]
        else sums[index] = ''
      })
      return sums
    },
    handleDatetime(dates) {
      const [start, end] = dates
      const limitDate = moment(end).subtract(90, 'days')

      if (limitDate.isAfter(start)) {
        this.$Message.warning('日期范围不能超过90天！')
        const newDate = limitDate.format('YYYY-MM-DD')
        this.datetime = [newDate, end]
      }

      this.sendEvent()
    },

    sendEvent() {
      this.getData()
    },
    getData() {
      const [beginTime, endTime] = this.datetime || []
      const param = {
        platform: this.platform,
        mediaId: this.mediaId,
        dataGameId: this.dataGameId,
        dataGroupId: this.dataGroupId,
        imageId: this.id,
        beginTime,
        endTime,
        sort: this.sort,
        order: this.order
      }
      this.loading = true
      getMaterialRecordDetail(param).then((data) => {
        this.loading = false
        if (!data) return
        const { imageInfo, rows, sumdata } = data
        // 素材基本信息
        if (imageInfo) {
          this.name = imageInfo.imageName
          this.author = imageInfo.designerName
          this.creatime = typeof imageInfo.uploadTime === 'number' ? datetimeToDay(imageInfo.uploadTime) : imageInfo.uploadTime
        }
        if (isArray(rows) && sumdata) {
          this.sumdata = sumdata
          this.tableList = rows
        }
      })
    },
    downData() {
      const [beginTime, endTime] = this.datetime || []
      const path = '/api/ptom/media/downloadMaterialDetailReport'
      const url = `${HOST_API}${path}?`

      const params = {
        sessionid: this.$store.state.token,
        platform: this.platform,
        mediaId: this.mediaId,
        dataGameId: this.dataGameId,
        dataGroupId: this.dataGroupId,
        imageId: this.id
      }

      if (beginTime && endTime) {
        params.beginTime = beginTime
        params.endTime = endTime
      }

      if (this.sort) params.sort = this.sort
      if (this.order) params.order = this.order

      const queryString = new URLSearchParams(params).toString()

      window.open(url + queryString)
    },
    proLoadData() {
      this.mediaId = Number(this.$route.query.mediaId) || ''
      this.dataGameId = Number(this.$route.query.dataGameId) || ''
      this.dataGroupId = Number(this.$route.query.dataGroupId) || ''
      this.sendEvent()
    }
  },
  data() {
    return {
      tableHeight: 330,
      id: this.$route.query.id,
      platform: String(this.$route.query.platform),
      dataGameId: null,
      dataGroupId: null,
      name: null,
      author: null,
      creatime: null,
      begintime: null,
      endtime: null,
      mediaId: '', // 媒体id
      columns: [], // 表格字段
      tableList: [], // 表格数据
      sumdata: [], // 统计数据
      datetime: []
    }
  },
  watch: {
    columns: {
      handler(nVal) {
        const show = nVal.filter((ret) => !ret.show).map((met) => met.key)
        this.setCustomStorage('MaterDCustomColumn', show)
      },
      deep: true
    }
  },
  created() {
    const { beginTime, endTime } = this.$route.query
    this.datetime = [beginTime, endTime]
    const shows = this.getCustomStorage('MaterDCustomColumn')
    columns = reportCols
    // 同步本地存储自定义列
    if (shows.length) {
      const local_shows = shows
        .filter((ret) => ret)
        .map((ret) => {
          const item = columns.filter((met) => met.key === ret).pop() || {}
          item.show = false
          return item
        })
      const extend_shows = columns
        .filter((ret) => !shows.includes(ret.key))
        .map((ret) => {
          ret.show = true
          return ret
        })
      this.columns = [...local_shows, ...extend_shows]
    } else {
      this.columns = [...columns]
    }

    this.proLoadData()
  }
}
</script>
<style lang="scss" scoped>
.material-report-detail {
  position: relative;

  .material-info-row {
    margin-bottom: 8px;
    > span {
      margin-right: 8px;
      .text {
        color: red;
      }
    }
  }

  .c-form {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
</style>
